const Debouche = () => {
    return (
        <>
            <div className="slide" id="debouche">
                <div className="wrapper">
                    <h1>Débouchés</h1>
                    <p>
                        Le certificat de qualification en vidéaste ouvre la porte à une variété de métiers dans les secteurs artistiques, culturels, commerciaux ou numériques.
                    </p>
                        <hr />
                    <p>
                        Tu pourras exercer notamment en tant que :
                    </p>
                    <ul>
                        <li>Vidéaste indépendant : art, publicité, film de commande..</li>
                        <li>Réalisateur ou assistant-réalisateur : fiction, documentaire, clip musical...</li>
                        <li>Technicien image et son : cadreur, preneur de son, monteur, mixeur...</li>
                        <li>Assistant en production audiovisuelle : direction ou gestion de production, distribution, logistique de tournage</li>
                        <li>Créateur de contenu web</li>
                        <li>Artiste VFX (effets spéciaux)</li>
                        <li>Scénariste</li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default Debouche;